window.addEventListener("load", function() {
  // Récupérer les éléments de formulaire
  var dream1 = document.getElementById("dream1");
  var dream2 = document.getElementById("dream2");
  var dreamDescription = document.getElementById("dream_description");

  // Masquer dream2 si dream1 n'a pas de valeur sélectionnée, et disable textarea si dream1 est utilisé
  dream1.addEventListener("change", function() {
    document.getElementById("collage").classList.remove("d-none");
    document.getElementById("collage").classList.remove("gone");
    document.getElementById("answer").classList.add("d-none");
    document.getElementById("answer_block").classList.add("d-none");
    document.getElementById("question_block").classList.add("d-none");
    document.getElementById("social").classList.remove("d-flex");
    document.getElementById("social").classList.add("d-none");
    document.getElementById("answer_logo").classList.add("d-none");
    if (dream1.value === "") {
      dream2.style.display = "none";
      dreamDescription.disabled = false;
    } else {
      dream2.style.display = "block";
      dreamDescription.disabled = true;
    }
  });

  dreamDescription.addEventListener("change", function() {
    document.getElementById("collage").classList.remove("d-none");
    document.getElementById("collage").classList.remove("gone");
    document.getElementById("answer").classList.add("d-none");
    document.getElementById("answer_block").classList.add("d-none");
    document.getElementById("question_block").classList.add("d-none");
    document.getElementById("social").classList.remove("d-flex");
    document.getElementById("social").classList.add("d-none");
    document.getElementById("answer_logo").classList.add("d-none");
    if (dreamDescription.value !== "") {
      dream1.disabled = true;
      dream2.disabled = true;
    } else {
      dream1.disabled = false;
      dream2.disabled = false;
    }
  });

  var toRevelateur = document.getElementById("toRevelateur");
  toRevelateur.addEventListener("click", function() {
    document.getElementById("revelateur").scrollIntoView(true);
  });

  var dreams = [];

  // Stocker les valeurs uniques de la propriété "Catégorie"
  const categories = [...new Set(dreams.map((obj) => obj.Catégorie))];

  // Mettre à jour le champ select dream1 avec les valeurs uniques de "Catégorie"
  categories.forEach((category) => {
    const option = document.createElement("option");
    option.text = category.charAt(0).toUpperCase() + category.slice(1);
    option.value = category.charAt(0).toUpperCase() + category.slice(1);
    dream1.add(option);
  });

  // Mettre à jour le champ select dream2 en fonction de la catégorie sélectionnée
  dream1.addEventListener("change", () => {
    const selectedCategory = dream1.value;
    const dream2 = document.getElementById("dream2");
    dream2.innerHTML = "";
    const option = document.createElement("option");
    option.text = "Plus précisément";
    option.value = "";
    dream2.add(option);
    dreams
      .filter(
        (obj) => obj.Catégorie.toLowerCase() === selectedCategory.toLowerCase()
      )
      .map((obj) => obj.Thème)
      .forEach((theme) => {
        const option = document.createElement("option");
        option.text = theme.charAt(0).toUpperCase() + theme.slice(1);
        option.value = theme.charAt(0).toUpperCase() + theme.slice(1);
        dream2.add(option);
      });
  });

  dreamDescription.addEventListener("keyup", () => {
    var maxlen = dreamDescription.getAttribute("maxlength");
    var info = document.getElementById("textarea_message");

    var length = dreamDescription.value.length;
    if (length > maxlen - 10) {
      info.textContent = maxlen + " caractères maximum.";
    } else {
      info.textContent = "";
    }
  });
});

document.addEventListener("DOMContentLoaded", () => {
  // Récupérer les éléments du formulaire et du bouton
  const form = document.querySelector("#revelateur_form");
  const dream1 = document.querySelector("#dream1");
  const dream2 = document.querySelector("#dream2");
  const dreamDescription = document.querySelector("#dream_description");
  const interpretes = document.querySelectorAll(".interprete");
  const launchBtn = document.querySelector("#send_dream");
  const loader = document.getElementById("submitLoader");

  // Ajouter un écouteur d'événements sur le bouton "Lancer l'interprétation"
  launchBtn.addEventListener("click", (event) => {
    event.preventDefault();
    loader.classList.remove("d-none");
    document.getElementById("answerLoader").classList.remove("d-none");
    document.getElementById("answer_logo").classList.add("d-none");
    document.getElementById("collage").classList.remove("d-none");
    //document.getElementById('collage').classList.remove("gone");
    document.getElementById("answer").classList.add("d-none");
    document.getElementById("answer_block").classList.add("d-none");
    document.getElementById("question_block").classList.add("d-none");
    document.getElementById("social").classList.remove("d-flex");
    document.getElementById("social").classList.add("d-none");
    document.getElementById("right_part").scrollIntoView(true);
    //document.getElementById('collage').classList.add("gone");
    launchBtn.disabled = true;
    // Récupérer les données du formulaire
    const data = {
      dream1: dream1.value,
      dream2: dream2.value,
      dreamDescription: dreamDescription.value,
      interprete: ""
    };

    if (data.dream1 != "") {
      var myDream = data.dream1;
      var isFixed = true;
      if (data.dream2 != "") {
        var myDream = data.dream2;
      }
    } else {
      var myDream = data.dreamDescription;
      var isFixed = false;
    }

    // Trouver l'interprète sélectionné
    interpretes.forEach((interprete) => {
      if (interprete.classList.contains("selected")) {
        data.interprete = interprete.querySelector("p").textContent;
      }
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "interpretation",
      dream1: data.dream1,
      dream2: data.dream2,
      interprete: data.interprete,
      isFixed: dream1 != "" ? false : true
    });

    // Envoyer les données à l'API avec une requête HTTP
    fetch(
      "https://ps5nr0ww29.execute-api.us-east-1.amazonaws.com/dev/interpret-dream/text",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          persona: data.interprete,
          dream: myDream,
          isFixed: isFixed,
          language: "fr"
        })
      }
    )
      .then((response) => {
        if (response) {
          // console.log(response);
          return response.json();
        } else {
          throw console.log("Erreur de l'API");
        }
      })
      .then((response) => {
        var answer = document.getElementById("answer");
        var message = response.message.normalize();
        console.log(message);
        loader.classList.add("d-none");
        document.getElementById("collage").classList.add("d-none");
        document.getElementById("answer").classList.remove("d-none");
        document.getElementById("answer_block").classList.remove("d-none");
        document.getElementById("question_block").classList.remove("d-none");
        document.getElementById("answerLoader").classList.add("d-none");
        // effet typewriter : affiche un caractère après l'autre
        var i = 0;
        answer.innerHTML = "";
        function typeWriter() {
          if (i < message.length) {
            answer.innerHTML += message.charAt(i);
            i++;
            setTimeout(typeWriter, 50);
          }
          if (i === message.length) {
            document.getElementById("social").classList.remove("d-none");
            document.getElementById("social").classList.add("d-flex");
            document.getElementById("answer_logo").classList.remove("d-none");
            launchBtn.disabled = false;
          }
        }
        typeWriter();

        // Tim ajout dynamique personnage

        document.getElementById("nom_interprete_question").innerHTML =
          data.interprete;
        document.getElementById("description_reve_question").innerHTML =
          data.dreamDescription;

        var image_URL = document
          .getElementsByClassName("selected")[0]
          .firstElementChild.getAttribute("src");
        document
          .getElementById("answer_block_interprete_logo")
          .setAttribute("src", image_URL);
        document.getElementById("answer_block_interprete_name").innerHTML =
          data.interprete;
      })
      .catch((error) => {
        console.error(error);
        alert(
          "Une erreur est survenue lors de l'interprétation de votre rêve."
        );
      });
  });

  // Ajouter un écouteur d'événements sur les interprètes pour les sélectionner
  interpretes.forEach((interprete) => {
    interprete.addEventListener("click", () => {
      interpretes.forEach((otherInterprete) => {
        otherInterprete.classList.remove("selected");
      });
      interprete.classList.add("selected");
      if (window.innerWidth < 768) {
        document.getElementById("send_dream").scrollIntoView(false);
      }
    });
  });
});
